<ndc-dynamic 
[ndcDynamicComponent]="filterImplementationComponent"
[ndcDynamicInputs]="inputs"
[ndcDynamicOutputs]="outputs"
></ndc-dynamic>